import React from 'react';
import Button from '@material-ui/core/Button';

import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import SelectionList from '../SelectionList';
import { ASSIGN_MARKETPLACE_MESSAGE } from '../../static-content';
import NavigationTabs from '../nav/NavigationTabs';

import ButtonContent from '../ButtonContent'
import { COLORS } from '../../styles/colors';

import { AlertJsMessage } from './../../helpers.js'

const UNSELECT_WARNING_MESSAGE = `Are you sure you want to remove this workout from the marketplace?`;

const sortByAdded = (a,b) => {
  if (a.added > b.added) {
    return -1;
  }
  if (a.added < b.added) {
    return 1;
  }
  return 0;
}

class MarketplaceForm extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      itemType: 'workout',
      dataLoaded: false,
      selectedItems: {},
    };
  }
  componentDidMount(){
    const { fetch } = this.props;
    fetch().then(() => {
      let workouts = this.props.workouts;
      let selected = {};
      Object.values(workouts).map((workout, index) => {
        if (workout.privacy === 'public') {
          selected[workout.id] = workout;
        }
        return null;
      })
      this.setState({
        ...this.state,
        dataLoaded: true,
        selectedItems: selected
      })
    });
  }
  handleChange = field => event => {
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        [field]: event.target.value
      }
    })
  }

  submitForm(){
    const { selectedItems } = this.state;
    const { assignToPartners, assignments } = this.props;
    const partnerAssignments = assignments.partner;
    const ids = Object.values(selectedItems)
      .sort(sortByAdded)
      .map((item) => item.id)
      .toString();
    assignToPartners(ids, partnerAssignments).then((data) => {
      AlertJsMessage("Done Assigning");
    });
  }
  handleToggleType = (event, type) => {
    if (type) {
      let selected = {};
      const { workouts, programs} = this.props;
      const items = type === 'workout' ? workouts : programs;
      Object.values(items).map((item, index) => {
        if (item.privacy === 'public') {
          selected[item.id] = item;
        }
        return null;
      })
      this.setState({
        ...this.state,
        selectedItems: selected,
        itemType: type
      })
    }

  }
  render(){
    const { selectedItems, dataLoaded, itemType } = this.state;
    const { workouts, workoutCats, programs } = this.props;
    const items = itemType === 'workout' ? workouts : programs;
    if (dataLoaded) {
      return (
        <div>
          <NavigationTabs
            title="Assign"
            subtitle="Marketplace"
            description={ASSIGN_MARKETPLACE_MESSAGE}
            set="assign"
            activeRoute="/assign/marketplace" />

          <div style={{
              paddingBottom: 10,
              marginTop: 25,}}>
            <ToggleButtonGroup value={itemType}
              onChange={this.handleToggleType} exclusive>
              <ToggleButton value='workout' selected={itemType === 'workout'}>
                Workouts
              </ToggleButton>
              <ToggleButton

                value="program"
                selected={itemType === 'program'}>
                Programs
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div style={{
                display: 'flex',
                border: '1px solid ' + COLORS.grey
              }}>

              <div style={{width:'50%', borderRight: '1px solid ' + COLORS.grey, paddingTop: 10, paddingBottom: 10}}>
                <SelectionList
                  addSelectedClass={true}
                  items={Object.values(items)}
                  selectedItems={selectedItems}
                  updateSelectedItems={(selected) => this.setState({...this.state, selectedItems: selected})}
                  categories={Object.values(workoutCats)}
                  categoryField="categoryId"
                  creatorTabs={true}
                  defaultTab={0}
                  user={this.props.user}
                  hideTabs={[1,2]}
                  unselectWarningMessage={UNSELECT_WARNING_MESSAGE}
                  />
              </div>

              <div style={{width:'50%', paddingTop: 10, paddingBottom: 10}}>
                <SelectionList
                  items={Object.values(items)}
                  selectedItems={selectedItems}
                  updateSelectedItems={(selected) => this.setState({...this.state, selectedItems: selected})}
                  categories={Object.values(workoutCats)}
                  categoryField="categoryId"
                  creatorTabs={true}
                  defaultTab={2}
                  tabAlias={['','','Marketplace']}
                  user={this.props.user}
                  hideTabs={[0,1]}
                  unselectWarningMessage={UNSELECT_WARNING_MESSAGE}
                  />
                {
                  Object.values(selectedItems).length ? (
                    <Button
                      style={{float:'right', margin: 5}}
                      onClick={() => this.submitForm()}
                      variant="contained"
                      color="primary">
                      <ButtonContent
                        text="Assign Now"
                        icon="clipboard-check"
                        />

                    </Button>
                  ) : null
                }
              </div>


            </div>
        </div>
      )
    }
    return null;
  }
}

export default MarketplaceForm;



// WEBPACK FOOTER //
// ./src/components/assignments/MarketplaceForm.js